// Investor Slider
var investor_thumbs = new Swiper('.investor_thumbs', {
  spaceBetween: 0,
  loop: true,
  slidesPerView: 1,
  freeMode: false,
  watchSlidesProgress: true,
});

var investor_slider = new Swiper('.investor_slider', {
  thumbs: {
    swiper: investor_thumbs,
  },
  navigation: {
    nextEl: '.custom-arrow-next',
    prevEl: '.custom-arrow-prev',
  },
  slidesPerView: 1.25,
  loop: true,
  centeredSlides: false,
  spaceBetween: 0,
  breakpoints: {
    720: {
      slidesPerView: 2.5,
      spaceBetween: 0,
    },
  },
});